import React from 'react'
import EyRnButton from '../../../../components/EyRnButton/EyRnButton';
import styles from "./AIChatRoom.module.scss";

export default function AIChatRoom() {
  return (
    <div className={styles.chatBox}>
      <div className={styles.room}>
        <div className={styles.chat}>
          <div className={styles.chatInfo}>
            <h6 className={styles.chatInfoName}>AI</h6>
            <span className={styles.chatInfoTime}>Now</span>
          </div>

          <div className={styles.chatBubbleModule}>
            I've come up with 3 plans to help mitigate this risk.
          </div>
        </div>

        <div className={styles.chat}>
          <div className={styles.chatInfo}>
            <h6 className={styles.chatInfoName}>AI</h6>
            <span className={styles.chatInfoTime}>Now</span>
          </div>

          <div className={styles.chatBubble}>
            <div className={styles.badge}>
              <i className="icon-trending-down"></i>
            </div>

            <div className={styles.chatBubbleContent}>
              <h6>1.Find new vendor in unaffected region</h6>
              <p>
                Finding new vendor in another will allow you to continue
                operation as usual. This has allow cost and risk.
              </p>
            </div>
          </div>
        </div>

        <div className={styles.chat}>
          <div className={styles.chatInfo}>
            <h6 className={styles.chatInfoName}>AI</h6>
            <span className={styles.chatInfoTime}>Now</span>
          </div>
          <div className={styles.chatBubble}>
            <div className={styles.badge}>
              <i className="icon-trending-up"></i>
            </div>

            <div className={styles.chatBubbleContent}>
              <h6>2.Bring more manufacturing in-house </h6>
              <p>
                Bring in more manufacturing in-house will you give greater
                control of your supply chain. This has a long ramp-up time and
                cost involved through
              </p>
            </div>
          </div>
        </div>

        <div className={styles.chat}>
          <div className={styles.chatInfo}>
            <h6 className={styles.chatInfoName}>AI</h6>
            <span className={styles.chatInfoTime}>Now</span>
          </div>
          <div className={styles.chatBubble}>
            <div className={styles.badge}>
              <i className="icon-trending-down"></i>
            </div>
            <div className={styles.chatBubbleContent}>
              <h6>3.Purchase new vendor</h6>
              <p>
                We found 3 vendors who have been negatively affected by the
                supply chain issues. This would be a good time to buy at a lower
                price and control the market.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-end">
        <div className="tag bg-gray-500 text-white"> Show me a component </div>
        <div className="tag bg-gray-500 text-white"> Create a report </div>
        <div className="tag bg-gray-500 text-white"> Monitor this risk </div>
      </div>
    </div>
  );
}
